import * as Sentry from "@sentry/react";
import appConfig from "../utils/config";

const initializeSentry = () => {
  if (appConfig.enableSentry) {
    Sentry.init({
        dsn: "https://d1c33e94c18f7be52e11b1123e296105@o4510603589910528.ingest.de.sentry.io/4510619015643216",
        integrations: [
          Sentry.browserTracingIntegration(),
          Sentry.replayIntegration(),
          Sentry.captureConsoleIntegration(),
        ],
        tracesSampleRate: 1.0, //  Capture 100% of the transactions
        tracePropagationTargets: ["localhost", "https://rsidms.com/"],
        replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
        replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
        sendDefaultPii: true,
      });
  }
};

export default initializeSentry;
